﻿; (() => {
    const section =
        document.getElementById("products") || document.querySelector(".products-section");
    if (!section) return;

    const grid = section.querySelector(".bg-grid");
    if (!grid) return;

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) return;

    // Tune this for more/less movement (0.15 = very subtle)
    const intensity = 0.15;

    let ticking = false;

    function update() {
        const rect = section.getBoundingClientRect();

        // Progress of the section within the viewport (-vh to +height)
        const viewportH = window.innerHeight || document.documentElement.clientHeight; // kept (even if unused)
        const offset = rect.top * intensity;

        grid.style.setProperty("--parallax-y", offset.toFixed(2) + "px");
        ticking = false;
    }

    function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
    }

    // Initial paint + listeners
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
})();
